<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">C<span class="small">ONTENTS</span></p>
<p class="toc"><a href="#/Acknowledgements">Acknowledgements</a></p>
<p class="toc"><a href="#/Introduction">Introduction</a></p>
<p class="toc1"><span href="#/Chapter1#C1" title="Link target outside of Sample">1. Dumfries</span></p>
<p class="toc2"><span href="#/Chapter1#S1-1" title="Link target outside of Sample">Rippon Lodge</span></p>
<p class="toc2"><span href="#/Chapter1#S1-2" title="Link target outside of Sample">Weems-Botts House</span></p>
<p class="toc2"><span href="#/Chapter1#S1-3" title="Link target outside of Sample">Williams Ordinary</span></p>
<p class="toc1"><span href="#/Chapter2#C2" title="Link target outside of Sample">2. Occoquan</span></p>
<p class="toc2"><span href="#/Chapter2#S2-1" title="Link target outside of Sample">Occoquan Inn</span></p>
<p class="toc2"><span href="#/Chapter2#S2-2" title="Link target outside of Sample">The Shops</span></p>
<p class="toc1"><span href="#/Chapter3#C3" title="Link target outside of Sample">3. Haymarket</span></p>
<p class="toc2"><span href="#/Chapter3#S3-1" title="Link target outside of Sample">Snow Hill</span></p>
<p class="toc2"><span href="#/Chapter3#S3-2" title="Link target outside of Sample">Rattlesnake Grahams</span></p>
<p class="toc2"><span href="#/Chapter3#S3-3" title="Link target outside of Sample">Buckland Mills</span></p>
<p class="toc2"><span href="#/Chapter3#S3-4" title="Link target outside of Sample">La Grange</span></p>
<p class="toc2"><span href="#/Chapter3#S3-5" title="Link target outside of Sample">Thoroughfare Gap</span></p>
<p class="toc2"><span href="#/Chapter3#S3-6" title="Link target outside of Sample">Cloverland</span></p>
<p class="toc1"><span href="#/Chapter4#C4" title="Link target outside of Sample">4. Bristow</span></p>
<p class="toc2"><span href="#/Chapter4#S4-1" title="Link target outside of Sample">Brentsville Courthouse</span></p>
<p class="toc2"><span href="#/Chapter4#S4-2" title="Link target outside of Sample">Independent Hill</span></p>
<p class="toc1"><span href="#/Chapter5#C5" title="Link target outside of Sample">5. Nokesville</span></p>
<p class="toc2"><span href="#/Chapter5#S5-1" title="Link target outside of Sample">Broadlands Farm</span></p>
<p class="toc1"><span href="#/Chapter6#C6" title="Link target outside of Sample">6. Bull Run</span></p>
<p class="toc2"><span href="#/Chapter6#S6-1" title="Link target outside of Sample">The Battlefield</span></p>
<p class="toc2"><span href="#/Chapter6#S6-2" title="Link target outside of Sample">Ben Lomond</span></p>
<p class="toc1"><span href="#/Chapter7#C7" title="Link target outside of Sample">7. Manassas</span></p>
<p class="toc2"><span href="#/Chapter7#S7-1" title="Link target outside of Sample">Olde Towne Inn</span></p>
<p class="toc2"><span href="#/Chapter7#S7-2" title="Link target outside of Sample">The Things I Love</span></p>
<p class="toc2"><span href="#/Chapter7#S7-3" title="Link target outside of Sample">Old Town Hall</span></p>
<p class="toc1"><span href="#/Chapter8#C8" title="Link target outside of Sample">8. Death and Society</span></p>
<p class="toc2"><span href="#/Chapter8#S8-1" title="Link target outside of Sample">Religion and Death</span></p>
<p class="toc2"><span href="#/Chapter8#S8-2" title="Link target outside of Sample">Gender, Fashion and Traditions</span></p>
<p class="toc2"><span href="#/Chapter8#S8-3" title="Link target outside of Sample">Waking the Dead</span></p>
<p class="toc2"><span href="#/Chapter8#S8-4" title="Link target outside of Sample">Picturing the Dead</span></p>
<p class="toc2"><span href="#/Chapter8#S8-5" title="Link target outside of Sample">Containing the Dead</span></p>
<p class="toc2"><span href="#/Chapter8#S8-6" title="Link target outside of Sample">Tombstones and Their Meanings</span></p>
<p class="toc2"><span href="#/Chapter8#S8-7" title="Link target outside of Sample">The Lady of Death</span></p>
<p class="toc1"><span href="#/Chapter9#C9" title="Link target outside of Sample">9. Ghosts of a Different Kind</span></p>
<p class="toc1"><span href="#/Bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?48db0bb8